export interface ModelOption {
  id: string
  name: string
  tier: 'fast' | 'balanced' | 'powerful'
  contextWindow: number
}

export interface ModelProvider {
  id: string
  name: string
  apiKeyPlaceholder: string
  apiKeyUrl: string
  models: ModelOption[]
  defaultModel: string
}

export const MODEL_PROVIDERS: ModelProvider[] = [
  {
    id: 'anthropic',
    name: 'Anthropic',
    apiKeyPlaceholder: 'sk-ant-...',
    apiKeyUrl: 'https://console.anthropic.com/settings/keys',
    defaultModel: 'claude-sonnet-4-6',
    models: [
      { id: 'claude-opus-4-7',           name: 'Claude Opus 4.7',    tier: 'powerful',  contextWindow: 200000 },
      { id: 'claude-opus-4-6',           name: 'Claude Opus 4.6',    tier: 'powerful',  contextWindow: 200000 },
      { id: 'claude-sonnet-4-6',         name: 'Claude Sonnet 4.6',  tier: 'balanced',  contextWindow: 200000 },
      { id: 'claude-haiku-4-5-20251001', name: 'Claude Haiku 4.5',   tier: 'fast',      contextWindow: 200000 },
    ],
  },
  {
    id: 'openai',
    name: 'OpenAI',
    apiKeyPlaceholder: 'sk-...',
    apiKeyUrl: 'https://platform.openai.com/api-keys',
    defaultModel: 'gpt-4.1-mini',
    models: [
      { id: 'gpt-4.1',         name: 'GPT-4.1',         tier: 'powerful',  contextWindow: 1000000 },
      { id: 'gpt-4.1-mini',    name: 'GPT-4.1 Mini',    tier: 'balanced',  contextWindow: 1000000 },
      { id: 'gpt-4.1-nano',    name: 'GPT-4.1 Nano',    tier: 'fast',      contextWindow: 1000000 },
      { id: 'gpt-4o',          name: 'GPT-4o',           tier: 'balanced',  contextWindow: 128000  },
      { id: 'gpt-4o-mini',     name: 'GPT-4o Mini',     tier: 'fast',      contextWindow: 128000  },
      { id: 'o3',              name: 'o3',               tier: 'powerful',  contextWindow: 200000  },
      { id: 'o4-mini',         name: 'o4 Mini',         tier: 'balanced',  contextWindow: 200000  },
    ],
  },
  {
    id: 'google-genai',
    name: 'Google Gemini',
    apiKeyPlaceholder: 'AIza...',
    apiKeyUrl: 'https://aistudio.google.com/apikey',
    defaultModel: 'gemini-2.5-flash',
    models: [
      { id: 'gemini-2.5-pro',        name: 'Gemini 2.5 Pro',         tier: 'powerful',  contextWindow: 1000000 },
      { id: 'gemini-2.5-flash',      name: 'Gemini 2.5 Flash',       tier: 'balanced',  contextWindow: 1000000 },
      { id: 'gemini-2.0-flash',      name: 'Gemini 2.0 Flash',       tier: 'fast',      contextWindow: 1000000 },
      { id: 'gemini-2.0-flash-lite', name: 'Gemini 2.0 Flash Lite',  tier: 'fast',      contextWindow: 1000000 },
    ],
  },
  {
    id: 'mistralai',
    name: 'Mistral AI',
    apiKeyPlaceholder: 'sk-...',
    apiKeyUrl: 'https://console.mistral.ai/api-keys',
    defaultModel: 'mistral-small-latest',
    models: [
      { id: 'mistral-large-latest',   name: 'Mistral Large',   tier: 'powerful',  contextWindow: 128000 },
      { id: 'mistral-medium-latest',  name: 'Mistral Medium',  tier: 'balanced',  contextWindow: 128000 },
      { id: 'mistral-small-latest',   name: 'Mistral Small',   tier: 'fast',      contextWindow: 128000 },
    ],
  },
  {
    id: 'groq',
    name: 'Groq',
    apiKeyPlaceholder: 'gsk_...',
    apiKeyUrl: 'https://console.groq.com/keys',
    defaultModel: 'llama-3.3-70b-versatile',
    models: [
      { id: 'llama-3.3-70b-versatile',     name: 'Llama 3.3 70B',        tier: 'balanced',  contextWindow: 128000 },
      { id: 'llama-3.1-70b-versatile',     name: 'Llama 3.1 70B',        tier: 'balanced',  contextWindow: 128000 },
      { id: 'llama-3.1-8b-instant',        name: 'Llama 3.1 8B Instant', tier: 'fast',      contextWindow: 128000 },
      { id: 'gemma2-9b-it',               name: 'Gemma 2 9B',            tier: 'fast',      contextWindow: 8192   },
      { id: 'mixtral-8x7b-32768',         name: 'Mixtral 8x7B',         tier: 'balanced',  contextWindow: 32768  },
    ],
  },
  {
    id: 'deepseek',
    name: 'DeepSeek',
    apiKeyPlaceholder: 'sk-...',
    apiKeyUrl: 'https://platform.deepseek.com/api_keys',
    defaultModel: 'deepseek-chat',
    models: [
      { id: 'deepseek-reasoner', name: 'DeepSeek R1',   tier: 'powerful',  contextWindow: 64000 },
      { id: 'deepseek-chat',     name: 'DeepSeek V3',   tier: 'balanced',  contextWindow: 64000 },
    ],
  },
]

export const PROVIDER_MAP: Record<string, ModelProvider> = Object.fromEntries(
  MODEL_PROVIDERS.map((p) => [p.id, p])
)
